import { createStyles, type StylesClasses } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    padding: {
      xs: '0px 24px !important',
      md: '0px 6.5% !important',
      lg: '0px 6.5% !important',
    },
  },
  socialWrapper: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    maxWidth: 'fit-content',
    flexWrap: 'wrap',
    flexDirection: { xs: 'column', md: 'row' },
    rowGap: '8px',
  },
  socialOuterWrapper: {
    display: 'flex',
    gap: '24px',
    alignItems: 'center',
    maxWidth: 'fit-content',
  },
})

export default styles

export type StylesClassNames = StylesClasses<typeof styles>
